// extracted by mini-css-extract-plugin
export default {"header":"CookiesText_header__ZDtYG","block":"CookiesText_block__wsDLe"};